
import {Component, Prop, Vue} from "vue-property-decorator";
import {store} from "../Store";
import {clearAll} from "../api/cache";
import BackArrow from "./BackArrow.vue";
import {navigateToSearch} from '../lib/search';

@Component({
    components: {
        BackArrow
    },
})
export default class Toolbar extends Vue {

    data = store.data;
    cacheClearing = false;


    fontAdd(sum: number) {
        this.data.toolbar.fontSize += sum;
    }

    toggleCols() {
        this.data.toolbar.cols = (this.data.toolbar.cols === "1") ? "2" : "1";
    }

    clearCache() {
        this.cacheClearing = true;
        clearAll();
        setTimeout(() => {
            this.cacheClearing = false;
        }, 1500)
    }

    getRandom() {
        const len = store.data.songs.length;
        const song = store.data.songs[Math.floor(Math.random() * len)];
        return song;
    }

    randomSong() {
        const song = this.getRandom();
        const to = {name: 'song', params: {id: song.id.toString()}};
        this.$router.push(to);
    }

    submitSearch() {
        navigateToSearch(this.data.currentFilter);
    }

    toggleSearch() {
        store.toggleSearchingMode();
        this.$nextTick(() => {
            if (this.data.searchingMode) {
                const search = <HTMLInputElement>this.$refs.search;
                search.focus();
            }
        })
    }

}
